import type { NewsArticle } from "@/types/news";

/** Loose database/editorial article row shape used across weekly, daily and AI panels. */
export interface ArticleRowLike {
  id: string;
  title: string;
  excerpt?: string | null;
  summary?: string | null;
  url?: string | null;
  image_url?: string | null;
  imageUrl?: string | null;
  published_at?: string | null;
  publishedAt?: string | null;
  source_id?: string | null;
  source_name?: string | null;
  category?: string | null;
  read_time?: string | null;
  likes_count?: number | null;
  comments_count?: number | null;
  slug?: string | null;
  author_name?: string | null;
  author_avatar?: string | null;
  content_cleaned_at?: string | null;
}

/** Normalizes any article-ish row into the NewsArticle shape ArticleCard renders. */
export function toNewsArticle(row: ArticleRowLike): NewsArticle {
  return {
    id: row.id,
    title: row.title,
    excerpt: row.excerpt ?? row.summary ?? "",
    url: row.url ?? "",
    imageUrl: row.image_url ?? row.imageUrl ?? "",
    publishedAt: row.published_at ?? row.publishedAt ?? new Date().toISOString(),
    source: {
      id: row.source_id ?? "byteline",
      name: row.source_name ?? row.source_id ?? "Byteline",
    },
    slug: row.slug ?? null,
    updatedAt: row.content_cleaned_at ?? null,
    author: row.author_name
      ? { name: row.author_name, ...(row.author_avatar ? { avatar: row.author_avatar } : {}) }
      : undefined,
    category: row.category ?? undefined,
    readTime: row.read_time ?? undefined,
    likes_count: row.likes_count ?? 0,
    comments_count: row.comments_count ?? 0,
  };
}
